import { addMessage, useAppDispatch } from '@lotta/self-service/lottery-fe/data-access-state';
import { isApiError } from '@lotta/self-service/lottery-fe/util-utilities';
import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';

type Translations = { [key: number]: string };

type RtkQueryError = FetchBaseQueryError | SerializedError | undefined;
const DEFAULT_ERROR_KEY = 'general-something-went-wrong';
const ERROR_TYPE = 'ERROR';

/**
 * Hook to handle errors from RTK Query by triggering a toast. Triggers toast when error is defined.
 * @param error Error from query
 * @param translations Object to map error code to error message
 */
export const useErrorToast = (error: RtkQueryError, translations?: Translations): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (error) {
      if ('data' in error && isApiError(error.data)) {
        const {
          data: { statusCode, code },
        } = error;

        if (statusCode && code) {
          dispatch(
            addMessage({
              code,
              key: translations?.[statusCode] ?? DEFAULT_ERROR_KEY,
              type: ERROR_TYPE,
            })
          );
          return;
        }
      }

      dispatch(
        addMessage({
          code: 'SOMETHING_WENT_WRONG',
          key: DEFAULT_ERROR_KEY,
          type: ERROR_TYPE,
        })
      );
    }
  }, [dispatch, error, translations]);
};
